import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {HelmetProvider, Helmet} from 'react-helmet-async';
import {useDispatch, useSelector} from "react-redux";
import {apiEndPoints} from "../../api/network/apiEndPoints";
import {fetchPosts} from "../../api/redux/post";
import ControlPreventionDetailsPage from "../../components/ControlPrevention/ControlPreventionDetailsPage";
import {ApiParam as ApiParamKey} from "../../api/network/apiParams";
import {fetchChild} from "../../api/redux/controlprevention";
import InnerBannerTwo from "../../components/InnerBannerTwo";
import {useLocation} from "react-router-dom";

const ControlPreventionDetails = () => {

    const dispath = useDispatch()
    const getData = useSelector(state=> state.controlPreventionReducer)

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialDetails = queryParams.get('details');
    const [details, setDetails] = useState(initialDetails);
    // api call
    useEffect(() => {
        let apiUrl = apiEndPoints.CHILD_PAGE
        let apiUrlSection = apiEndPoints.SECTIONS

        let api_params = {
            [ApiParamKey.page_id]: 123,
            [ApiParamKey.sections]: 'yes',
            [ApiParamKey.image]: 'yes',
            [ApiParamKey.post]: 'yes',
            [ApiParamKey.file]: 'no',
        }
        let api_params_sections = {
            [ApiParamKey.type]: 'slug',
            [ApiParamKey.value]: 'control--prevention',
            [ApiParamKey.get_section]: 'yes',
            [ApiParamKey.image]: 'yes',
            [ApiParamKey.post]: 'yes',
            [ApiParamKey.file]: 'no',
        }

        dispath(fetchChild([apiUrl, api_params]))
        dispath(fetchPosts([apiUrlSection, api_params_sections]))
    }, [])

    const DetailsPage = getData?.child?.data?.list;
    const BannerData = getData?.child?.data?.list?.find(f=>f?.page_data?.slug === details);
    const page_data = BannerData?.page_data;

    return (

        <HelmetProvider>
            <Helmet>
                <title>{`${page_data?.title ? page_data?.title + ' | ' : ''}`}National Heart
                    Foundation</title>

                <meta name="meta:title" content={page_data?.meta_title}/>
                <meta name="description" content={page_data?.meta_description}/>
                <meta property="og:title" content={page_data?.og_title}/>
                <meta property="og:subtitle" content={page_data?.og_title}/>
                <meta property="og:description" content={page_data?.og_description}/>
                <meta property="og:image" content={BannerData?.images?.list?.[0]?.full_path}/>
                <meta property="og:url" content={window?.location?.href}/>
                <meta property="og:type" content={"website"}/>
            </Helmet>

            <StyledComponent>

                {
                    BannerData &&
                    <InnerBannerTwo
                        img={BannerData?.images?.list[1]?.full_path ? BannerData?.images?.list[1]?.full_path : ''}/>
                }

                {
                    DetailsPage &&
                    <ControlPreventionDetailsPage data={DetailsPage}/>
                }

            </StyledComponent>
        </HelmetProvider>

    );
};

const StyledComponent = styled.section`

`;

export default ControlPreventionDetails;
